import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useDataValue, useDataSubmit } from 'Simple/Data'
import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_booking',
    path: '_id',
  })
  let submit = useDataSubmit({
    context: 'appointment_booking',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!value.chair_id || !value.provider_id || !value.assistant_id) {
      return true
    }

    let mutationResponse = await executeMutation({
      id,
      provider_id: value.provider_id,
      assistant_id: value.assistant_id,
      chair_id: value.chair_id,
    })
    if (mutationResponse.error) {
      notify(
        notifyError(
          `There was a problem updating the appointment. Please try again.`
        )
      )
      return
    }
    submit({ type: 'reFetch' })
    submit({
      type: 'showPatient',
      tab: 'treatment_card',
    })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
